import i18n from '../config/i18n';
import Cookies from 'js-cookie';

const COOKIE_NAME = 'i18nextLng';
const POLL_INTERVAL = 1000; // Check every second

let lastCookieValue: string | undefined;
let pollInterval: number | null = null;

/**
 * Gets the current language cookie value
 */
function getCookieValue(): string | undefined {
    return Cookies.get(COOKIE_NAME);
}

/**
 * Checks if the cookie has changed and updates i18n if needed
 */
function checkCookieChange() {
    const currentCookieValue = getCookieValue();
    
    if (currentCookieValue !== lastCookieValue) {
        lastCookieValue = currentCookieValue;
        
        // Only update if the cookie value is different from current language
        if (currentCookieValue && currentCookieValue !== i18n.language) {
            // Normalize language code (handle 'en-US' -> 'en', 'fr-CA' -> 'fr')
            const normalizedLang = currentCookieValue.startsWith('en') 
                ? 'en' 
                : currentCookieValue.startsWith('fr') 
                ? 'fr' 
                : currentCookieValue;
            
            if (normalizedLang !== i18n.language) {
                i18n.changeLanguage(normalizedLang);
            }
        }
    }
}

/**
 * Starts listening for cookie changes
 * Uses polling and window focus events to detect changes
 */
export function startI18nCookieListener() {
    // Initialize with current cookie value
    lastCookieValue = getCookieValue();
    
    // Check on window focus (when user switches back to tab/window)
    const handleFocus = () => {
        checkCookieChange();
    };
    
    window.addEventListener('focus', handleFocus);
    
    // Poll periodically as a fallback
    pollInterval = window.setInterval(() => {
        checkCookieChange();
    }, POLL_INTERVAL);
    
    // Return cleanup function
    return () => {
        window.removeEventListener('focus', handleFocus);
        if (pollInterval !== null) {
            clearInterval(pollInterval);
            pollInterval = null;
        }
    };
}

/**
 * Stops listening for cookie changes
 */
export function stopI18nCookieListener(cleanup: () => void) {
    cleanup();
}

